import React from 'react';
import { Setting, Edit, PreviewOpen } from '@icon-park/react';

function MobileNav({ mobileView, onChange, onPreview }) {
  return (
    <div className="mobile-bottom-nav">
      <button
        className={`mobile-nav-btn ${mobileView === 'settings' ? 'active' : ''}`}
        onClick={() => onChange('settings')}
      >
        <span className="mobile-nav-icon"><Setting theme="outline" size={18} fill="#333" strokeWidth={3} /></span>
        <span className="mobile-nav-text">设置</span>
      </button>
      <button
        className={`mobile-nav-btn ${mobileView === 'editor' ? 'active' : ''}`}
        onClick={() => onChange('editor')}
      >
        <span className="mobile-nav-icon"><Edit theme="outline" size={18} fill="#333" strokeWidth={3} /></span>
        <span className="mobile-nav-text">编辑</span>
      </button>
      <button
        className={`mobile-nav-btn ${mobileView === 'preview' ? 'active' : ''}`}
        onClick={onPreview}
      >
        <span className="mobile-nav-icon"><PreviewOpen theme="outline" size={18} fill="#333" strokeWidth={3} /></span>
        <span className="mobile-nav-text">预览</span>
      </button>
    </div>
  );
}

export default MobileNav;
